import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import SearchBar from '../../../elements/SearchBar';
import { Button } from '@mui/material';

const LinkedTestCaseActions = ({
  searchValue,
  setSearchValue,
  selectedTestSuite,
  setSelectedTestSuite,
  selectAll,
  testSuites,
  handleSelectAll,
  showSelect = false,
}) => {
  return (
    <Row className="align-items-center mb-3">
      <Col className="d-flex" md={4}>
        <SearchBar
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          clearSearch={() => setSearchValue('')}
          placeholder="Search Test Cases"
        />
      </Col>
      <Col sm={3}>
        <Form.Group controlId="linkedTestSuite" title="Filter by Test Suite">
          <Form.Select
            value={selectedTestSuite}
            onChange={(e) => setSelectedTestSuite(e.target.value)}
            className="form-input"
            aria-label="Filter by Test Suite"
          >
            <option value="all">All Test Suites</option>
            {testSuites?.map((suite) => (
              <option key={suite.id} value={suite.id}>
                {suite.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      {showSelect && (
        <Col>
          <Button variant="text" onClick={handleSelectAll} disableRipple>
            {selectAll ? 'Deselect All' : 'Select All'}
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default LinkedTestCaseActions;
